import * as React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceReviewEvaluationsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import Loading from 'modules/layout/components/Page/Loading'
import { DueDate } from 'modules/performance_process/components//review/common/DueDate'
import { CompletionBarWithTitle } from 'modules/performance_process/components/common/CompletionBarWithTitle'
import { EvaluationGrid } from 'modules/performance_process/components/common/EvaluationGrid'
import { useFlow } from 'modules/performance_process/hooks/useFlow'

export const MyReviews: React.FC = () => {
  const { reviewId } = useParams()
  const { access } = useCurrentSession()

  const { data, loading, error } = useQuery(PerformanceReviewEvaluationsDocument, {
    variables: { id: Number(reviewId), currentUserAccessId: access.id },
  })
  const deadline = data?.performance.reviewProcess?.endsAt
  const reviewIsFinished = data?.performance.reviewProcess?.status === 'finished'

  const { from } = useFlow()

  const totalReviewsTofill = data?.performance.reviewProcess?.totalReviewsTofill.totalCount
  const totalCompletedReviewsTofill =
    data?.performance.reviewProcess?.totalCompletedReviewsTofill.totalCount

  if (loading || error) return <Loading />

  return (
    <Box gap="s32">
      <Box gap="s12">
        <Text size="500" weight="semibold" color="grey1000">
          {i18n.t('performance_process.reviews.completed_reviews')}
        </Text>
        <Text.Normal>
          {i18n.t('performance_process.reviews.completed_reviews_description')}
        </Text.Normal>
        {!reviewIsFinished && deadline && <DueDate deadline={deadline} />}
      </Box>
      <Box>
        <Box gap="s48">
          {totalReviewsTofill != null && totalCompletedReviewsTofill != null && (
            <CompletionBarWithTitle
              completed={totalCompletedReviewsTofill}
              total={totalReviewsTofill}
            />
          )}
          {data?.performance?.pendingEvaluations && (
            <EvaluationGrid
              status={'pending'}
              evaluations={data?.performance?.pendingEvaluations}
              reviewId={Number(reviewId)}
              currentAccessId={access.id}
              celebrate={from === 'evaluation-completion'}
            />
          )}
          {data?.performance?.publishedEvaluations && (
            <EvaluationGrid
              status={'published'}
              evaluations={data?.performance?.publishedEvaluations || []}
              reviewId={Number(reviewId)}
              currentAccessId={access.id}
            />
          )}
        </Box>
        <Outlet />
      </Box>
    </Box>
  )
}
